import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { KanziPrimeUiModule } from '@kanzi-apes/kanzi-prime-ui';
import { AlertComponent } from './alert';
import { AlertConfirmComponent } from './alert-confirm';
import { AlertBookingComponent } from './alert-booking/alert-booking.component';
import { AlertVoiceComponent } from './alert-voice';

@NgModule({
  imports: [
    CommonModule,
    KanziPrimeUiModule,
    TranslateModule.forChild({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    }),
    RouterModule,
    ReactiveFormsModule,
  ],
  declarations: [
    AlertComponent,
    AlertBookingComponent,
    AlertConfirmComponent,
    AlertVoiceComponent,
  ],
  exports: [
    AlertComponent,
    AlertBookingComponent,
    AlertConfirmComponent,
    AlertVoiceComponent,
  ],
})
export class KanziAlertsModule {}
